import { Component, OnInit, OnDestroy, Inject, LOCALE_ID, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthService } from './shared/services/auth.service';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { NavigationEnd, Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'app';
  lang: string = 'en';

  private subscription: Subscription;
  private authenticated: string;

  constructor(private gtmService: GoogleTagManagerService, private router: Router, @Inject(DOCUMENT) private document: Document,
    @Inject(LOCALE_ID) private localeId: string,
    private renderer: Renderer2) {
    let prodUrl = [ 'idi-bidit.com', 'www.idi-bidit.com'];
    if (prodUrl.indexOf(document.location.hostname) >= 0) {
      this.router.events.forEach(item => {
        if (item instanceof NavigationEnd) {
          const gtmTag = {
            event: 'page',
            pageName: item.url
          };
          this.gtmService.pushTag(gtmTag);
        }
      });
    }

    this.setLanguage(this.localeId);


    let token = localStorage.getItem('token');
    if (token != null && router.url.indexOf('changePassword') < 0) {
      localStorage.removeItem('token');
      router.navigate(['login', 'changePassword', token]);
    }

    let ackHash = localStorage.getItem('ackHash');
    if (ackHash != null && router.url.indexOf('acknowledge') < 0) {
      localStorage.removeItem('ackHash');
      router.navigate(['weblink', 'acknowledge', ackHash]);
    }
  }

  ngOnInit() {
    console.log("appInit");

    console.log(`window loc href ${window.location.href}`);
    console.log(`window loc path ${window.location.pathname}`);
    console.log(`window loc origin ${window.location.origin}`);

    this.subscription = AuthService.authNavStatus$.subscribe(authenticated => this.authenticated = authenticated);
  }

  ngOnDestroy() {
    // prevent memory leak when component is destroyed
    this.subscription.unsubscribe();
  }

  setLanguage(lang: string): void {
    this.renderer.setAttribute(this.document.documentElement, 'lang', lang);
  }

  changeLanguage(lang: string): void {
    this.setLanguage(lang);
    this.lang = lang;
  }
}
